/* THIS FILE IS AUTO-GENERATED – DO NOT EDIT */

import {Color, ColorHues, ColorTint, ColorTints} from './types'

/** @public */
export const black: ColorTint = {
  title: 'Black',
  hex: '#0d0e12',
}

/** @public */
export const white: ColorTint = {
  title: 'White',
  hex: '#ffffff',
}

/** @public */
export const gray: ColorTints = {
  '50': {
    title: 'Gray 50',
    hex: '#f6f6f8',
  },
  '100': {
    title: 'Gray 100',
    hex: '#eeeef1',
  },
  '200': {
    title: 'Gray 200',
    hex: '#e3e4e8',
  },
  '300': {
    title: 'Gray 300',
    hex: '#bbbdc9',
  },
  '400': {
    title: 'Gray 400',
    hex: '#9499ad',
  },
  '500': {
    title: 'Gray 500',
    hex: '#727892',
  },
  '600': {
    title: 'Gray 600',
    hex: '#515870',
  },
  '700': {
    title: 'Gray 700',
    hex: '#383d51',
  },
  '800': {
    title: 'Gray 800',
    hex: '#252837',
  },
  '900': {
    title: 'Gray 900',
    hex: '#1b1d27',
  },
  '950': {
    title: 'Gray 950',
    hex: '#13141b',
  },
}

/** @public */
export const blue: ColorTints = {
  '50': {
    title: 'Blue 50',
    hex: '#f5f8ff',
  },
  '100': {
    title: 'Blue 100',
    hex: '#e5edff',
  },
  '200': {
    title: 'Blue 200',
    hex: '#dbe5ff',
  },
  '300': {
    title: 'Blue 300',
    hex: '#a8bfff',
  },
  '400': {
    title: 'Blue 400',
    hex: '#7595ff',
  },
  '500': {
    title: 'Blue 500',
    hex: '#556bfc',
  },
  '600': {
    title: 'Blue 600',
    hex: '#4043e7',
  },
  '700': {
    title: 'Blue 700',
    hex: '#2927aa',
  },
  '800': {
    title: 'Blue 800',
    hex: '#192457',
  },
  '900': {
    title: 'Blue 900',
    hex: '#161a41',
  },
  '950': {
    title: 'Blue 950',
    hex: '#101228',
  },
}

/** @public */
export const purple: ColorTints = {
  '50': {
    title: 'Purple 50',
    hex: '#f8f5ff',
  },
  '100': {
    title: 'Purple 100',
    hex: '#f1ebff',
  },
  '200': {
    title: 'Purple 200',
    hex: '#ece1fe',
  },
  '300': {
    title: 'Purple 300',
    hex: '#ccb1fc',
  },
  '400': {
    title: 'Purple 400',
    hex: '#b087f7',
  },
  '500': {
    title: 'Purple 500',
    hex: '#8f57ef',
  },
  '600': {
    title: 'Purple 600',
    hex: '#721fe5',
  },
  '700': {
    title: 'Purple 700',
    hex: '#4c1a9e',
  },
  '800': {
    title: 'Purple 800',
    hex: '#2f1862',
  },
  '900': {
    title: 'Purple 900',
    hex: '#23173f',
  },
  '950': {
    title: 'Purple 950',
    hex: '#181128',
  },
}

/** @public */
export const magenta: ColorTints = {
  '50': {
    title: 'Magenta 50',
    hex: '#fef6f9',
  },
  '100': {
    title: 'Magenta 100',
    hex: '#fde8ef',
  },
  '200': {
    title: 'Magenta 200',
    hex: '#fcdee9',
  },
  '300': {
    title: 'Magenta 300',
    hex: '#f7abc5',
  },
  '400': {
    title: 'Magenta 400',
    hex: '#f0709b',
  },
  '500': {
    title: 'Magenta 500',
    hex: '#e72767',
  },
  '600': {
    title: 'Magenta 600',
    hex: '#b11651',
  },
  '700': {
    title: 'Magenta 700',
    hex: '#7c1342',
  },
  '800': {
    title: 'Magenta 800',
    hex: '#4b1130',
  },
  '900': {
    title: 'Magenta 900',
    hex: '#341325',
  },
  '950': {
    title: 'Magenta 950',
    hex: '#1f0f14',
  },
}

/** @public */
export const red: ColorTints = {
  '50': {
    title: 'Red 50',
    hex: '#fff6f5',
  },
  '100': {
    title: 'Red 100',
    hex: '#ffe7e5',
  },
  '200': {
    title: 'Red 200',
    hex: '#ffdedc',
  },
  '300': {
    title: 'Red 300',
    hex: '#fdada5',
  },
  '400': {
    title: 'Red 400',
    hex: '#f77769',
  },
  '500': {
    title: 'Red 500',
    hex: '#ef4434',
  },
  '600': {
    title: 'Red 600',
    hex: '#cc2819',
  },
  '700': {
    title: 'Red 700',
    hex: '#8b2018',
  },
  '800': {
    title: 'Red 800',
    hex: '#4d1714',
  },
  '900': {
    title: 'Red 900',
    hex: '#321615',
  },
  '950': {
    title: 'Red 950',
    hex: '#1e1011',
  },
}

/** @public */
export const orange: ColorTints = {
  '50': {
    title: 'Orange 50',
    hex: '#fff7f0',
  },
  '100': {
    title: 'Orange 100',
    hex: '#ffeadb',
  },
  '200': {
    title: 'Orange 200',
    hex: '#ffddc7',
  },
  '300': {
    title: 'Orange 300',
    hex: '#ffb685',
  },
  '400': {
    title: 'Orange 400',
    hex: '#ff8e42',
  },
  '500': {
    title: 'Orange 500',
    hex: '#fa6400',
  },
  '600': {
    title: 'Orange 600',
    hex: '#b14802',
  },
  '700': {
    title: 'Orange 700',
    hex: '#7c3404',
  },
  '800': {
    title: 'Orange 800',
    hex: '#461e07',
  },
  '900': {
    title: 'Orange 900',
    hex: '#32160b',
  },
  '950': {
    title: 'Orange 950',
    hex: '#21120d',
  },
}

/** @public */
export const yellow: ColorTints = {
  '50': {
    title: 'Yellow 50',
    hex: '#fefae1',
  },
  '100': {
    title: 'Yellow 100',
    hex: '#fcf3bb',
  },
  '200': {
    title: 'Yellow 200',
    hex: '#f9e994',
  },
  '300': {
    title: 'Yellow 300',
    hex: '#f7d455',
  },
  '400': {
    title: 'Yellow 400',
    hex: '#f9bc15',
  },
  '500': {
    title: 'Yellow 500',
    hex: '#d28a04',
  },
  '600': {
    title: 'Yellow 600',
    hex: '#965908',
  },
  '700': {
    title: 'Yellow 700',
    hex: '#653a0b',
  },
  '800': {
    title: 'Yellow 800',
    hex: '#3b220c',
  },
  '900': {
    title: 'Yellow 900',
    hex: '#271a11',
  },
  '950': {
    title: 'Yellow 950',
    hex: '#181410',
  },
}

/** @public */
export const green: ColorTints = {
  '50': {
    title: 'Green 50',
    hex: '#e7fef5',
  },
  '100': {
    title: 'Green 100',
    hex: '#c5fce8',
  },
  '200': {
    title: 'Green 200',
    hex: '#a9f9dc',
  },
  '300': {
    title: 'Green 300',
    hex: '#59f3ba',
  },
  '400': {
    title: 'Green 400',
    hex: '#0ff0a1',
  },
  '500': {
    title: 'Green 500',
    hex: '#04b97a',
  },
  '600': {
    title: 'Green 600',
    hex: '#01794f',
  },
  '700': {
    title: 'Green 700',
    hex: '#015133',
  },
  '800': {
    title: 'Green 800',
    hex: '#023120',
  },
  '900': {
    title: 'Green 900',
    hex: '#06231a',
  },
  '950': {
    title: 'Green 950',
    hex: '#071715',
  },
}

/** @public */
export const cyan: ColorTints = {
  '50': {
    title: 'Cyan 50',
    hex: '#e7fefe',
  },
  '100': {
    title: 'Cyan 100',
    hex: '#c5fcfc',
  },
  '200': {
    title: 'Cyan 200',
    hex: '#96f8f8',
  },
  '300': {
    title: 'Cyan 300',
    hex: '#62efef',
  },
  '400': {
    title: 'Cyan 400',
    hex: '#18e2e2',
  },
  '500': {
    title: 'Cyan 500',
    hex: '#04b8be',
  },
  '600': {
    title: 'Cyan 600',
    hex: '#037782',
  },
  '700': {
    title: 'Cyan 700',
    hex: '#024950',
  },
  '800': {
    title: 'Cyan 800',
    hex: '#042f34',
  },
  '900': {
    title: 'Cyan 900',
    hex: '#072227',
  },
  '950': {
    title: 'Cyan 950',
    hex: '#0d181c',
  },
}

/** @public */
export const hues: ColorHues = {gray, blue, purple, magenta, red, orange, yellow, green, cyan}

/** @public */
export const color: Color = {black, white, ...hues}
